// src/config/constants.js
export const HOTEL_NAME = "TOSENAT 3 ARENA";
